import React from 'react';
import { Table, Loader, Grid, Icon, Label } from 'semantic-ui-react';
import axios from 'axios';

export const fetchCourses = (studentStudyProgramId) => axios.get(`course/basic/not-passed/${studentStudyProgramId}/`);


export default class NotPassedCourses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            courses: [],
            loading: true
        };
    }


    componentDidMount() {
        const { studentStudyProgramId } = this.props;

        axios.get(`course/basic/not-passed/${studentStudyProgramId}/`)
            .then(res => {
                this.setState({
                    courses: res.data ? res.data : [], loading: false
                });
            })
            .catch(err => {
                console.log('Failed to fetch not passed courses.');
            });
    }


    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div >
                {/* <h3>Spisak nepoloženih predmeta</h3> */}
                {this.state.courses.length ?
                    <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Predmet</Table.HeaderCell>
                                <Table.HeaderCell width="2">Semestar</Table.HeaderCell>
                                <Table.HeaderCell width="3">Napomena</Table.HeaderCell>
                                <Table.HeaderCell width="4">ECTS</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {this.state.courses.map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell verticalAlign="middle">
                                    {index + 1}.
                                </Table.Cell>
                                <Table.Cell colSpan="2" verticalAlign="middle">
                                    <Grid columns={1} centered className="stackable">
                                        <Grid.Column width="10">
                                            {el.courseName}
                                            {/* <span >  { el.semesterNameKey === 'winter semester' ? <Icon name="snowflake" color="blue" /> : <Icon name="sun" color="yellow" />}{el.courseName}</span> */}
                                        </Grid.Column>
                                        <Grid.Column width="6" verticalAlign="middle" textAlign="right">

                                            <span style={{ color: '#a6a4a1' }}>

                                                {/* {el.courseBasicComment && <Label as="a" basic><Icon name="comment alternate" />{el.courseBasicComment}</Label>} */}
                                                {el.collision && <Label as="a" basic><Icon name="random" />Kolizija</Label>}

                                            </span>
                                        </Grid.Column>
                                    </Grid>

                                </Table.Cell>
                                {/* <Table.Cell verticalAlign="middle" warning={el.collision}> */}
                                {/*    {el.courseName} */}
                                {/* </Table.Cell> */}
                                <Table.Cell verticalAlign="middle">
                                    {el.semester}
                                </Table.Cell>

                                <Table.Cell verticalAlign="middle">
                                    {el.courseBasicComment}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.ects}
                                </Table.Cell>
                            </Table.Row>))}
                        </Table.Body>
                        <Table.Footer>
                            <Table.Row >
                                <Table.HeaderCell colSpan="5" rowSpan="3" />
                                <Table.HeaderCell >
                                    <h4>Ukupno ECTS bodova: {(this.state.courses.reduce((total, el) => total += el.ects, 0))}</h4>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer>
                    </Table>
                    : <p>Nema nepoloženih predmeta.</p>}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/NotPassedCourses.js